import React from 'react';
import UserIcon from 'images/icons/user.svg?react-svg';
import IconContainer from '../IconContainer';

export default function Icon() {
  return (
    <IconContainer>
      <UserIcon />
    </IconContainer>
  );
}
